"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailDesign = void 0;

var EmailDesign =
/** @class */
function () {
  function EmailDesign(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - emailDesignId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.GetEmailDesign = function (emailDesignId) {
    return this.restClient.get('EmailDesign/UseCase/GetEmailDesign', {
      emailDesignId: emailDesignId
    });
  };
  /**
   * @param string - emailDesignImageId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.GetEmailDesignImage = function (emailDesignImageId) {
    return this.restClient.get('EmailDesign/UseCase/GetEmailDesignImage', {
      emailDesignImageId: emailDesignImageId
    });
  };
  /**
   * @param string - eventId
   * @param number? - page
   * @param number? - itemsPerPage
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.ListEmailDesignsByEvent = function (eventId, page, itemsPerPage) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('EmailDesign/UseCase/ListEmailDesignsByEvent', {
      eventId: eventId,
      page: page,
      itemsPerPage: itemsPerPage
    });
  }; // Commands

  /**
   * @param string - name
   * @param string - layout
   * @param string - fromName
   * @param string - subject
   * @param string - content
   * @param string - backgroundColor
   * @param string - emailDesignTypeId
   * @param string - eventId
   * @param string? - fromEmail
   * @param string? - replyEmail
   * @param any[]? - ccEmail
   * @param any[]? - bccEmail
   * @param string? - domainMaskId
   * @param string? - domainMaskEmail
   * @param string? - emailDesignId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.CreateEmailDesign = function (name, layout, fromName, subject, content, backgroundColor, emailDesignTypeId, eventId, fromEmail, replyEmail, ccEmail, bccEmail, domainMaskId, domainMaskEmail, emailDesignId) {
    if (fromEmail === void 0) {
      fromEmail = null;
    }

    if (replyEmail === void 0) {
      replyEmail = null;
    }

    if (ccEmail === void 0) {
      ccEmail = null;
    }

    if (bccEmail === void 0) {
      bccEmail = null;
    }

    if (domainMaskId === void 0) {
      domainMaskId = null;
    }

    if (domainMaskEmail === void 0) {
      domainMaskEmail = null;
    }

    if (emailDesignId === void 0) {
      emailDesignId = null;
    }

    return this.restClient.post('EmailDesign/UseCase/CreateEmailDesign', {
      name: name,
      layout: layout,
      fromName: fromName,
      subject: subject,
      content: content,
      backgroundColor: backgroundColor,
      emailDesignTypeId: emailDesignTypeId,
      eventId: eventId,
      fromEmail: fromEmail,
      replyEmail: replyEmail,
      ccEmail: ccEmail,
      bccEmail: bccEmail,
      domainMaskId: domainMaskId,
      domainMaskEmail: domainMaskEmail,
      emailDesignId: emailDesignId
    });
  };
  /**
   * @param string - name
   * @param string - layout blank|alt-email-layout
   * @param string - fromName
   * @param string - subject
   * @param string - backgroundColor
   * @param string - emailDesignTypeId
   * @param string - eventId
   * @param string - emailTemplateType simple-template|simple-header|simple-template-border|default-invite|full-width-header
   * @param string? - fromEmail
   * @param string? - replyEmail
   * @param any[]? - ccEmails
   * @param any[]? - bccEmails
   * @param string? - domainMaskId
   * @param string? - domainMaskEmail
   * @param string? - emailDesignId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.CreateEmailDesignFromTemplate = function (name, layout, fromName, subject, backgroundColor, emailDesignTypeId, eventId, emailTemplateType, fromEmail, replyEmail, ccEmails, bccEmails, domainMaskId, domainMaskEmail, emailDesignId) {
    if (fromEmail === void 0) {
      fromEmail = null;
    }

    if (replyEmail === void 0) {
      replyEmail = null;
    }

    if (ccEmails === void 0) {
      ccEmails = null;
    }

    if (bccEmails === void 0) {
      bccEmails = null;
    }

    if (domainMaskId === void 0) {
      domainMaskId = null;
    }

    if (domainMaskEmail === void 0) {
      domainMaskEmail = null;
    }

    if (emailDesignId === void 0) {
      emailDesignId = null;
    }

    return this.restClient.post('EmailDesign/UseCase/CreateEmailDesignFromTemplate', {
      name: name,
      layout: layout,
      fromName: fromName,
      subject: subject,
      backgroundColor: backgroundColor,
      emailDesignTypeId: emailDesignTypeId,
      eventId: eventId,
      emailTemplateType: emailTemplateType,
      fromEmail: fromEmail,
      replyEmail: replyEmail,
      ccEmails: ccEmails,
      bccEmails: bccEmails,
      domainMaskId: domainMaskId,
      domainMaskEmail: domainMaskEmail,
      emailDesignId: emailDesignId
    });
  };
  /**
   * @param string - eventId
   * @param any - image image/jpeg|image/png
   * @param string? - emailDesignImageId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.CreateEmailDesignImage = function (eventId, image, emailDesignImageId) {
    if (emailDesignImageId === void 0) {
      emailDesignImageId = null;
    }

    return this.restClient.postMultipart('EmailDesign/UseCase/CreateEmailDesignImage', {
      eventId: eventId,
      image: image,
      emailDesignImageId: emailDesignImageId
    });
  };
  /**
   * @param string - originalEmailDesignId
   * @param string? - duplicateEventId
   * @param string? - duplicateEmailDesignId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.DuplicateEmailDesign = function (originalEmailDesignId, duplicateEventId, duplicateEmailDesignId) {
    if (duplicateEventId === void 0) {
      duplicateEventId = null;
    }

    if (duplicateEmailDesignId === void 0) {
      duplicateEmailDesignId = null;
    }

    return this.restClient.post('EmailDesign/UseCase/DuplicateEmailDesign', {
      originalEmailDesignId: originalEmailDesignId,
      duplicateEventId: duplicateEventId,
      duplicateEmailDesignId: duplicateEmailDesignId
    });
  };
  /**
   * @param string - emailDesignId
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.RemoveEmailDesign = function (emailDesignId) {
    return this.restClient.post('EmailDesign/UseCase/RemoveEmailDesign', {
      emailDesignId: emailDesignId
    });
  };
  /**
   * @param string - emailDesignId
   * @param string - name
   * @param string - layout
   * @param string - fromName
   * @param string - subject
   * @param string - content
   * @param string - backgroundColor
   * @param string - emailDesignTypeId
   * @param string - eventId
   * @param string? - fromEmail
   * @param string? - replyEmail
   * @param any[]? - ccEmail
   * @param any[]? - bccEmail
   * @param string? - domainMaskId
   * @param string? - domainMaskEmail
   * @return Promise|Observable|any
   */


  EmailDesign.prototype.UpdateEmailDesign = function (emailDesignId, name, layout, fromName, subject, content, backgroundColor, emailDesignTypeId, eventId, fromEmail, replyEmail, ccEmail, bccEmail, domainMaskId, domainMaskEmail) {
    if (fromEmail === void 0) {
      fromEmail = null;
    }

    if (replyEmail === void 0) {
      replyEmail = null;
    }

    if (ccEmail === void 0) {
      ccEmail = null;
    }

    if (bccEmail === void 0) {
      bccEmail = null;
    }

    if (domainMaskId === void 0) {
      domainMaskId = null;
    }

    if (domainMaskEmail === void 0) {
      domainMaskEmail = null;
    }

    return this.restClient.post('EmailDesign/UseCase/UpdateEmailDesign', {
      emailDesignId: emailDesignId,
      name: name,
      layout: layout,
      fromName: fromName,
      subject: subject,
      content: content,
      backgroundColor: backgroundColor,
      emailDesignTypeId: emailDesignTypeId,
      eventId: eventId,
      fromEmail: fromEmail,
      replyEmail: replyEmail,
      ccEmail: ccEmail,
      bccEmail: bccEmail,
      domainMaskId: domainMaskId,
      domainMaskEmail: domainMaskEmail
    });
  };

  return EmailDesign;
}();

exports.EmailDesign = EmailDesign;